module.exports = __webpack_public_path__ + "static/img/home-four-2.bf49693.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/home-four-2.png
// module id = b8Wn
// module chunks = 1